import { createAction, createReducer } from "@reduxjs/toolkit";

// Action creators
export const updateSettlementFormValues = createAction(
  "UPDATE_SETTLEMENT_FORM_VALUES"
);
export const resetSettlementFormValues = createAction(
  "RESET_SETTLEMENT_FORM_VALUES"
);
export const setClickedRowValue = createAction("SET_CLICKED_ROW_VALUE");

// Initial state
const initialState = {
  selectedYear: new Date().getFullYear().toString(),
  selectedGym: "",
  selectedMonth: "",
  selectedSettlementStartDate: "",
  selectedSettlementEndDate: "",
};

// Reducers
export const settlementFormReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(updateSettlementFormValues, (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    })
    .addCase(resetSettlementFormValues, () => initialState);
});

// Selector
export const selectSettlementFormValues = (state) => state.settlementForm;

// SETTLEMENT TABLE ROW VALUE PRESERVE
const initialRowState = {
  clickedRowValue: null,
};

export const clickedRowReducer = createReducer(initialRowState, (builder) => {
  builder.addCase(setClickedRowValue, (state, action) => {
    state.clickedRowValue = action.payload;
  });
});
